import { dispatch } from '../store';
import { showModal, hideModal } from '+/modal/redux';
// import history from '#/history';


export const wrapFetch = async callback => {


    try {

        const { data } = await callback();

        return data;
    }
    catch (error) {

        const { data, status } = error.response;

        const { message } = data || {};

        dispatch(showModal({
            title: 'Error',
            type: `fetch/${status}`,
            text: message || error.message,
            icon: 'error',
            onClose: () => {

                dispatch(hideModal());
                // history.goBack(); // ? porque
            }
        }));

        throw error;
    }
};

